<!-- template markdown -->
<template>
  <a @click="prompt_lang_select" class="lang-select">
    <img :alt="config.lang.country" :src="`https://hatscripts.github.io/circle-flags/flags/${config.lang.country}.svg`" width="24" class="flag">
    <span>
      {{ languages[config.lang.iso] }}
    </span>

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
    </svg>
  </a>
</template>

<script lang="ts">
import { config } from '@/conf'
import LangSelectModal from '@/components/ui/lang-select-modal.vue'
import { modal } from '@/components/main/modal'
import { languages } from '@/utils/language'

export default {
  setup () {

    // display language select modal
    const prompt_lang_select = () => {
      modal.show(LangSelectModal)
    }

    return {
      config,
      languages,
      prompt_lang_select
    }
  }
}
</script>
